import React from "react";
import { 
  Button, 
  Card, 
  Text,
} from "@fluentui/react-components";
import { useNavigate } from "react-router-dom";
import MetaData from "#root/layouts/MetaData";
import { ROUTES } from "#root/routes/constants";

const Unauthorized: React.FC = () => {
  const navigate = useNavigate();

  return (
    <>
      <MetaData
        title="401 Unauthorized"
        description="Sorry, you are not authorized to access this page."
      />
      <Card appearance="filled-alternative">
        <Text size={900} weight="bold" align="center">401</Text>
        <Text size={500} align="center">Sorry, you are not authorized to access this page.</Text>
        <Button appearance="primary" onClick={() => navigate(ROUTES.ROOT)} style={{ display: 'block', margin: '0 auto' }}>
          Back Home
        </Button>
      </Card>
    </>
  );
};

export default Unauthorized;
